import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-newteams',
  templateUrl: './newteams.component.html',
  styleUrls: ['./newteams.component.scss']
})
export class NewteamsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
